import { render } from "./App.vue?vue&type=template&id=3602fa30&bindings={\"config\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script